import Backbone from 'backbone'
import template from './historical-table.hbs'
import rowTemplate from './historical-table-row.hbs'
import _ from 'lodash'
import formatValue from 'scoreboard/components/format-value'
import StatusForm from './status-form'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import permissions from 'scoreboard/components/permissions'
import $ from 'jquery'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import NotesDialog from 'scoreboard/notes/notes-dialog'
import moment from 'moment'
import autofocus from 'scoreboard/polyfills/autofocus'
import guard from 'scoreboard/components/unsaved/guard'
import nonAbbreviatedValuesTooltip from 'scoreboard/components/non-abbreviated-values-tooltip.hbs'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import center from 'scoreboard/components/min-height-vertical-center-msg.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import guardConstants from 'scoreboard/components/unsaved/guard-constants'
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT, CURRENCY } = DataType

var HistoricalTable = Backbone.View.extend({

	// this.model is the initiative

	tagName: 'table',
	className: 'table table-striped historical-table has-dark-starting-cells',
	events: {
		'click .add-row': 'addStatus',
		'click .action-notes': 'notes',
		'click .action-edit': 'editStatus',
		'click .action-delete': 'deleteStatus'
	},

	initialize: function(opts) {
		this.treeCalculations = opts.treeCalculations
		this.statusForms = []
		this.hasNotesByDate = {}
		_.each(this.model.get('notes'), function (note) {
			this.hasNotesByDate[note.appliesTo] = true
		}.bind(this))
	},

	render: function() {
		// #15126 display message instead of empty table if no update status permissions
		if (!permissions.updateInitiativeStatus(this.model.get('organizationId'))
			&& _.isEmpty(this.model.get('statuses'))) {
			this.$el.empty()
				.append(center(i18n.get('initiatives.noStatuses')))
				.addClass('is-empty')
			return this
		}

		this.$el.empty().append(template(this.context()))
		var tbody = this.$('tbody')
		_.forEachRight(this.model.statuses(), function(status) {
			tbody.prepend(rowTemplate(this.rowData(status)))
		}.bind(this))

		this.secure()
		this.delegateEvents()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		this.tooltips = new TooltipAndDetails({
			el: this.el,
			selector: '[data-unshortened-value]',
			tooltipContent: e => nonAbbreviatedValuesTooltip({
				header: e.target.dataset.unshortenedHeader,
				value: e.target.dataset.unshortenedValue
			}),
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip initiatives-overview-historical-non-abbreviated-tooltip',
				placement: 'above'
			}
		})

		return this
	},

	context: function () {
		var statusType = this.model.statusType()
		return _.extend(this.model.toJSON(), {
			descendantStatuses: statusType === 'descendant',
			addingWillOverrideDescendants: statusType !== 'own',
			descendantsIgnored: this.model.statusType() === 'own' && this.model.get('descendantsHaveStatuses')
		})
	},

	secure: function() {
		var notes = this.model.get('createGlobalNotes') && permissions.isEditableIfReplicated(this.model)
		if (!permissions.updateInitiativeStatus(this.model.get('organizationId')) || !permissions.isEditableIfReplicated(this.model)) {
			this.$('.add-row, .action-edit, .action-delete').remove()
		}
		if (!permissions.updateInitiativeStatus(this.model.get('organizationId')) && !notes) {
			this.$('.table-actions-cell').remove()
			this.$el.addClass('is-non-editable')
		}
		if (!notes) {
			this.$('.actions-notes').remove()
		}
	},

	rowData: function(status) {
		var statusType = this.model.statusType()
		,	percentComplete = formatValue({ dataType: PERCENT, value: status.percentComplete })
		,	expendedToDate = formatValue({ dataType: CURRENCY, currencyCode: this.model.get('currencyCode'), value: status.expendedToDate })
		,	expendedToDateUnshortened = formatValue(_.extend({ dataType: CURRENCY, currencyCode: this.model.get('currencyCode'), value: status.expendedToDate }, {shorten: false}))
		return _.extend({}, status, {
			percentComplete,
			expendedToDate,
			expendedToDateUnshortened: expendedToDate == expendedToDateUnshortened ? null : expendedToDateUnshortened,
			hasNotes: this.hasNotesByDate[status.date],
			ownStatus: statusType === 'own',
			descendantStatus: statusType === 'descendant'
		})
	},

	addStatus: function() {
		if (this.model.statusType() !== 'own') {
			this.$el.empty().append(template())
		}

		var statusForm = new StatusForm({
			model: this.model,
			status: { date: new Date() },
			treeCalculations: this.treeCalculations,
			historicalTable: this
		})
		this.$('.add-row').before(statusForm.el).hide()
		statusForm.render()
		autofocus(statusForm.el)
		statusForm.once('done', function(status) {
			this.$('.add-row').show()
			// status will be undefined when nothing was entered for both
			// percentComplete and expendedToDate
			if (status) {
				this.$('.add-row').before(rowTemplate(this.rowData(status)))
			}
			statusForm.remove()
		}.bind(this))
		this.statusForms.push(statusForm)
	},

	// display notes dialog when user clicks on note icon
	notes: function(e) {
		var row = $(e.target).closest('tr')
		var date = row.data('date')
		var m = moment(date)

		function notesOnDate (note) {
			return m.isSame(moment(note.appliesTo))
		}

		var noteDialog = new NotesDialog({
			model: this.model,
			filter: notesOnDate,
			defaultTime: date
		})

		noteDialog.on('change:notes', function () {
			row.find('.action-notes').toggleClass('has-notes', _.filter(this.model.get('notes'), notesOnDate).length > 0)
		}.bind(this))

		appDisplay.dialog(noteDialog)
	},

	editStatus: function(e) {
		guard.conditionallyRun(function() {
			var row = $(e.target).closest('tr')

			var statusForm = new StatusForm({
				model: this.model,
				status: this.model.status(row.data('id')),
				treeCalculations: this.treeCalculations,
				historicalTable: this
			})
			row.before(statusForm.el).hide()
			statusForm.render()
			statusForm.on('done', function(status) {
				// don't update this row with another statuses data
				if (status.id != row.data('id')) return
				if (!status) {
					this.deleteStatus(e, statusForm)
					return
				}
				row.replaceWith(rowTemplate(this.rowData(status)))
				statusForm.remove()
			}.bind(this))
			this.statusForms.push(statusForm)
		}.bind(this))
	},

	deleteStatus: function(e, statusForm) {
		var confirmation = new DeleteConfirmation({
			description: i18n.get('initiatives.status')
		})
		appDisplay.dialog(confirmation)
		confirmation.on('confirm', function() {
			var row = $(e.currentTarget).closest('tr')

			this.model.once('remove:status', function () {
				row.remove()
				// handle deletes triggered by deleting all the data in the form
				statusForm && statusForm.remove()
				confirmation.trigger('done')
			})

			this.model.deleteStatus(row.data('id'), this.treeCalculations)
		}.bind(this))
	},

	multipleDirtyStatuses: function() {
		if (_.isNil(this.statusForms)) {
			return false
		}
		return this.statusForms.filter(sf => sf.formView.dirty == true).length > 1
	},

	removeTooltips: function() {
		_.invokeMap(this.statusForms, 'removeTooltips')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(_.flattenDeep([this.statusForms, this.covertButtonTooltips, this.tooltips]), 'remove')
	}

})

export default HistoricalTable

HistoricalTable.__filename__ = 'initiatives/overview/historical-table.js'
